/** Unused lines are retained as explicit, zero-valued invoice lines. */
export function normalizeUnusedInvoiceLine<T extends {description: string; quantityThousandths: number | null; unitAmountMinor: number | null}>(line: T): T {
  return !line.description.trim() && line.quantityThousandths === null && line.unitAmountMinor === null
    ? {...line, quantityThousandths: 1000, unitAmountMinor: 0} : line;
}

export function isIssuableInvoiceLine(line: {description: string; quantityThousandths: number | null; unitAmountMinor: number | null}): boolean {
  return line.quantityThousandths !== null && Number.isInteger(line.quantityThousandths) && line.quantityThousandths > 0
    && line.unitAmountMinor !== null && Number.isSafeInteger(line.unitAmountMinor)
    && (Boolean(line.description.trim()) || line.unitAmountMinor === 0);
}
